import React from "react";
import { Avatar } from "@mui/material";
import { useNavigate } from "react-router-dom";

const Dealmaker = ({ activity }) => {
  const navigate = useNavigate();
  return (
    <>
      {activity ? (
        <>
          <table className="plan_table mt-24">
            <thead className="plan_thead activityplan_thead">
              <tr>
                <th>Investee</th>
                <th>Investor</th>
                <th>Date</th>
                <th>Status</th>
                <th>Initiated by</th>
              </tr>
            </thead>
            {activity.length > 0 &&
              activity.map((res, i) => (
                <tr key={i} className="my-2 pt-2">
                  <td
                    onClick={() =>
                      navigate(
                        `/admin/user-activity?tab=13&userid=${res.investee?._id}`
                      )
                    }
                    className="pointer my-2 pt-2"
                  >
                    <Avatar src={res.investee ? res.investee.avatar : ""} />
                    {res.investee
                      ? `${res.investee.name} (${res.investee.firstname})`
                      : ""}
                  </td>
                  <td
                    onClick={() =>
                      navigate(
                        `/admin/user-activity?tab=13&userid=${res.investor?._id}`
                      )
                    }
                    className="pointer my-2 pt-2"
                  >
                    <Avatar src={res.investor ? res.investor.avatar : ""} />
                    {res.investor
                      ? `${res.investor.name} (${res.investor.firstname})`
                      : ""}
                  </td>
                  <td className=" pt-2">
                    {new Date(res.createdAt).toLocaleTimeString()}{" "}
                    {new Date(res.createdAt).toLocaleDateString()}
                  </td>

                  <td className=" my-2 pt-2">
                    {res.status === 2 ? (
                      <span style={{ color: "red" }}>Requested</span>
                    ) : res.status === 3 ? (
                      <span style={{ color: "red" }}>Declined</span>
                    ) : res.status === 4 ? (
                      <span style={{ color: "green" }}>Accepted</span>
                    ) : res.status === 5 ? (
                      <span style={{ color: "green" }}>Completed</span>
                    ) : res.status === 6 ? (
                      <span style={{ color: "red" }}>Deleted</span>
                    ) : (
                      <span style={{ color: "red" }}>Pending</span>
                    )}
                  </td>
                  <td className=" pt-2">{res.initiatedBy}</td>
                </tr>
              ))}
          </table>
        </>
      ) : (
        ""
      )}
    </>
  );
};

export default Dealmaker;
